// material-ui
import { styled } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';

// project imports
import { drawerWidth } from 'store/constant';

function openedMixin(theme) {
  return {
    width: drawerWidth,
    borderRight: theme.palette?.mode === 'dark' ? (theme.palette?.border?.default ? `1px solid ${theme.palette.border.default}` : '1px solid rgba(255, 255, 255, 0.08)') : 'none',
    zIndex: 1099,
    top: 72,
    height: 'calc(100vh - 72px)',
    background: theme.palette?.mode === 'dark' ? (theme.palette?.background?.sidebar || '#15171C') : (theme.palette?.background?.default || '#FFFFFF'),
    color: theme.vars?.palette?.text?.primary || theme.palette?.text?.primary,
    overflowX: 'hidden',
    boxShadow: 'none',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen + 200
    })
  };
}

function closedMixin(theme) {
  return {
    borderRight: theme.palette?.mode === 'dark' ? (theme.palette?.border?.default ? `1px solid ${theme.palette.border.default}` : '1px solid rgba(255, 255, 255, 0.08)') : 'none',
    zIndex: 1099,
    top: 72,
    height: 'calc(100vh - 72px)',
    background: theme.palette?.mode === 'dark' ? (theme.palette?.background?.sidebar || '#15171C') : (theme.palette?.background?.default || '#FFFFFF'),
    color: theme.vars?.palette?.text?.primary || theme.palette?.text?.primary,
    overflowX: 'hidden',
    width: 72,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen + 200
    })
  };
}

// ==============================|| DRAWER - MINI STYLED ||============================== //

const MiniDrawerStyled = styled(Drawer, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
  width: drawerWidth,
  borderRight: '0px',
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  top: 72,
  height: 'calc(100vh - 72px)',
  '& .MuiDrawer-paper': {
    top: 72,
    height: 'calc(100vh - 72px)',
    boxSizing: 'border-box',
    ...(open ? openedMixin(theme) : closedMixin(theme))
  },
  ...(open && openedMixin(theme)),
  ...(!open && closedMixin(theme))
}));

export default MiniDrawerStyled;
